import React from 'react';
import { feature } from 'react-openlayers';
import { Coordinate } from 'ol/coordinate';

type ParkingPointFeatureProps = {
  coords: Coordinate;
  id: string;
  selected?: boolean;
  properties?: [key: string];
  zIndex?: number;
};

const ParkingPointFeature = ({ coords, id, selected = false, properties, zIndex }: ParkingPointFeatureProps) => {
  return (
    <feature.PointReact
      coordinate={coords}
      iconOptions={{
        src: './images/parking-point.png',
        anchor: [0.5, 0.5],
        scale: selected ? 0.3 : 0.2,
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        opacity: 0.8,
      }}
      properties={properties}
      key={id}
      zIndex={zIndex}
    />
  );
};

export default ParkingPointFeature;
